var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMicPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "8y077kpsta",
    width: "118.1%",
    height: "115.5%",
    x: "-9%",
    y: "-7.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199491914 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8y077kpsta)",
    transform: "translate(-135 -3645) translate(102 3435)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.297 24.771c.65 0 1.222-.15 1.714-.454.491-.302.877-.72 1.157-1.255.28-.533.42-1.149.42-1.845v-5.84c0-.697-.14-1.312-.42-1.846-.28-.534-.666-.95-1.157-1.25-.492-.3-1.063-.449-1.714-.449-.645 0-1.214.15-1.71.45-.494.299-.88.715-1.156 1.25-.277.533-.415 1.148-.415 1.845v5.84c0 .696.138 1.312.415 1.846.276.533.662.952 1.157 1.254.495.303 1.064.454 1.709.454zm0-1.25c-.606 0-1.092-.21-1.46-.63-.368-.42-.552-.978-.552-1.674v-5.84c0-.697.184-1.255.552-1.675.368-.42.854-.63 1.46-.63.612 0 1.102.21 1.47.63.367.42.551.978.551 1.675v5.84c0 .696-.184 1.255-.551 1.675-.368.42-.858.63-1.47.63zm4.13 7.96c.177 0 .325-.06.445-.181.12-.12.18-.269.18-.445 0-.182-.06-.335-.18-.459-.12-.123-.268-.185-.444-.185H23.93v-2.289l.073-.006c.691-.058 1.336-.203 1.934-.435.798-.309 1.485-.745 2.061-1.308.576-.563 1.02-1.234 1.333-2.012.313-.778.469-1.642.469-2.593v-1.845c0-.176-.06-.326-.18-.45-.121-.123-.27-.185-.445-.185-.183 0-.334.062-.454.185-.12.124-.181.274-.181.45v1.797c0 1.041-.216 1.956-.65 2.744-.432.787-1.041 1.4-1.826 1.836-.784.436-1.707.654-2.768.654-1.055 0-1.974-.218-2.759-.654-.784-.437-1.393-1.049-1.826-1.836-.433-.788-.65-1.703-.65-2.744v-1.797c0-.176-.061-.326-.185-.45-.124-.123-.273-.185-.45-.185-.175 0-.323.062-.444.185-.12.124-.18.274-.18.45v1.845c0 .95.156 1.815.468 2.593.313.778.757 1.449 1.333 2.012.577.563 1.264 1 2.061 1.308.598.232 1.241.377 1.93.435l.067.005v2.29h-3.486c-.176 0-.326.062-.45.185-.123.124-.185.277-.185.46 0 .175.062.323.186.444.123.12.273.18.449.18h8.252z",
    transform: "translate(32 213) translate(.011)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicPurple);
export default __webpack_public_path__ + "static/media/ic_mic_purple.2132f90f897757603e1ddd6acd42ab59.svg";
export { ForwardRef as ReactComponent };